import { Outlet } from "react-router-dom"
import { HeaderNavMenu } from "./nav-menu"

export default function LandingLayout() {
  return (
    <>
      <HeaderNavMenu />
      <Outlet />
    </>
  )
}
